
import * as React from 'react';
import { ItemDefaultDropAction, IItemDefaultDropActionProps } from '../actions/defaultDrop/DefaultDropAction';
import { asActionDropZone, IDecorateAsActionDropZoneProps } from '../decorators/asActionDropZone';
import { isFileDropEvent } from '../../utilities/dragAndDrop/files';
import { withCurrentItem, IDecorateWithCurrentItemProps } from '../decorators/selectors';

export type IItemDefaultDropZoneProps = IDecorateAsActionDropZoneProps<IItemDefaultDropActionProps, {}>;

export const ItemDefaultDropZone: React.ComponentType<IItemDefaultDropZoneProps> =
    asActionDropZone(isFileDropEvent)(ItemDefaultDropAction);

export type IDefaultDropZoneProps = IDecorateWithCurrentItemProps<IItemDefaultDropZoneProps>;

export const DefaultDropZone: React.ComponentType<IDefaultDropZoneProps> =
    withCurrentItem()(asActionDropZone(isFileDropEvent)(ItemDefaultDropAction));
